<template>
  <div class="poi">
    <!-- <img :src="img" alt="" srcset=""> -->
    <valstatus
      v-for="(item, index) in val"
      class="mt"
      :info="item"
      :key="index"
    />
    
  </div>
</template>

<script>
// import img from '../img/4.png';
// import cfg from "./config.js";
import valstatus from "../valstatus/index.vue";
export default {
  components: { valstatus },
  props: ["datainfo"],
  mounted() {
    let val = [];
    let list = this.datainfo.data[0].formObjects;
    for (let index = 0; index < list.length; index++) {
      let item = list[index];
      let res = {};
      res.key = item.name;
      res.color = item.value == "-" ? "red" : "green";
      if (item.statusMap) {
        res.val = this.filterGetStatusByValue(
          this.filterJsonStrParse(item.value, "value"),
          item.statusMap
        );
      } else {
        res.val = item.value;
      }
      val.push(res);
    }
    this.val = val;
  },
  data() {
    return {
      val: [],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.poi {
  padding-top: 0.1rem;
}
.mt {
  margin-bottom: .05rem;
  // overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/data/iodi.vue